import { Menu, MenuItem, MenuItemText, Icon, ButtonWithMenu } from '@statsbomb/kitbag-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HELP_CENTER, CONTACT_SUPPORT } from '@/consts/links';

export const SupportLinks = ({ isMobile }: { isMobile?: boolean }) => {
  const { t } = useTranslation('general');
  const [isOpen, setIsOpen] = useState(false);
  const menuItems = [
    {
      label: t('helpCenter'),
      link: HELP_CENTER,
    },
    { label: t('contactUs'), link: CONTACT_SUPPORT },
  ];

  return (
    <ButtonWithMenu
      isOpen={isOpen}
      placement="bottom-end"
      onClick={() => setIsOpen(true)}
      onOutsideClick={() => setIsOpen(false)}
      variant={isMobile ? 'ghost' : 'secondary'}
      title={t('support')}
      icon="Support"
      size={isMobile ? 'regular' : 'small'}
    >
      <Menu onOutsideClick={() => setIsOpen(false)}>
        {menuItems.map(item => (
          <MenuItem key={item.label}>
            <a
              className="h-full w-full flex items-center justify-between"
              href={item.link}
              target="_blank"
              rel="noreferrer"
            >
              <MenuItemText>{item.label}</MenuItemText>
              <Icon variant="ChevronRight" size="small" />
            </a>
          </MenuItem>
        ))}
      </Menu>
    </ButtonWithMenu>
  );
};
